import { render, staticRenderFns } from "./pre_label.vue?vue&type=template&id=a027e20c&scoped=true"
import script from "./pre_label.vue?vue&type=script&lang=js"
export * from "./pre_label.vue?vue&type=script&lang=js"
import style0 from "./pre_label.vue?vue&type=style&index=0&id=a027e20c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a027e20c",
  null
  
)

export default component.exports